import React, { useContext, useMemo } from 'react';
import { LanguageContext } from '../../contexts/LanguageContext';
import { CATEGORIES, ITEMS, SECTIONS, label, menuIntro as intro } from '../../data/menuData';
import { RESTAURANT_WHATSAPP_DISPLAY, RESTAURANT_WHATSAPP_URL } from '../../constants/contact';
import './menu.css';

function countItems(sectionMap) {
  return Object.values(sectionMap).reduce((total, sectionItems) => {
    const visibleItems = sectionItems.filter(
      (item) => !item.header && !item.note && (item.name || item.name_es || item.name_en)
    ).length;

    return total + visibleItems;
  }, 0);
}

export default function MenuIntro({ onOpen }) {
  const { lang, t } = useContext(LanguageContext);
  const pageLang = ['en', 'es', 'ca'].includes(lang) ? lang : 'en';

  const previews = useMemo(
    () =>
      CATEGORIES.map((category) => ({
        id: category.id,
        label: label(category, pageLang),
        sectionCount: SECTIONS[category.id].length,
        itemCount: countItems(ITEMS[category.id]),
      })),
    [pageLang]
  );

  const introTitle =
    intro[`title_${pageLang}`] || intro.title_en || intro.title_es || 'Vatti Taverna menu';

  return (
    <section id="menu-intro" className="vt-menu-intro">
      <div className="vt-menu-hero">
        <div className="vt-cover-shell">
          <div className="vt-cover">
            <img src="/menu-cover.jpg" alt="Vatti Taverna menu cover" />
            <div className="vt-cover-content">
              <span className="vt-cover-badge">{t('menuExperienceKicker')}</span>
              <h3>{introTitle}</h3>
            </div>
          </div>
        </div>

        <div className="vt-menu-copy">
          <span className="section-kicker">{t('menuExperienceKicker')}</span>
          <h2 className="section-title vt-menu-title">{t('menu')}</h2>
          <p className="vt-description">{t('menuExperienceText')}</p>

          <div className="vt-menu-facts">
            {previews.map((preview, index) => (
              <div key={preview.id} className="vt-menu-fact">
                <span className="vt-menu-fact-index">{String(index + 1).padStart(2, '0')}</span>
                <div className="vt-menu-fact-copy">
                  <h3>{preview.label}</h3>
                  <p>
                    {preview.sectionCount} {t('menuPreviewSections')} / {preview.itemCount}{' '}
                    {t('menuPreviewDishes')}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="vt-action-row">
            <button type="button" className="vt-primary-btn" onClick={onOpen}>
              {t('viewMenu')}
            </button>

            <a
              className="vt-secondary-btn"
              href={RESTAURANT_WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {RESTAURANT_WHATSAPP_DISPLAY}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
